module.exports = __webpack_public_path__ + "static/media/JILI.ba2b911b.jpeg";